import { t as e } from "../utils-DiFe-_ei.js";
import { a as t, c as n, i as r, n as i, o as a, r as o, s, t as c } from "../dist-BWsUe_id.js";
import * as l from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
//#region src/foundations/dialog/dialog.tsx
var f = c, p = n, m = a, h = i, g = l.forwardRef(({ className: n, ...r }, i) => /* @__PURE__ */ u(t, {
	ref: i,
	className: e("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", n),
	...r
}));
g.displayName = t.displayName;
var _ = l.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ d(m, { children: [/* @__PURE__ */ u(g, {}), /* @__PURE__ */ u(o, {
	ref: i,
	className: e("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-bottom-5 data-[state=open]:slide-in-from-bottom-5 sm:rounded-lg", t),
	...r,
	children: n
})] }));
_.displayName = o.displayName;
var v = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col space-y-1.5 text-center sm:text-left", t),
	...n
});
v.displayName = "DialogHeader";
var y = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", t),
	...n
});
y.displayName = "DialogFooter";
var b = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(s, {
	ref: r,
	className: e("text-lg font-semibold leading-none tracking-tight", t),
	...n
}));
b.displayName = s.displayName;
var x = l.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ u(r, {
	ref: i,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
x.displayName = r.displayName;
//#endregion
export { f as Dialog, h as DialogClose, _ as DialogContent, x as DialogDescription, y as DialogFooter, v as DialogHeader, g as DialogOverlay, m as DialogPortal, b as DialogTitle, p as DialogTrigger };

//# sourceMappingURL=dialog.js.map